"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecError = exports.GitError = void 0;
__exportStar(require("./exec"), exports);
__exportStar(require("./spawn"), exports);
__exportStar(require("./parse-error"), exports);
__exportStar(require("./parse-bad-config-value-error-info"), exports);
var errors_1 = require("./errors");
Object.defineProperty(exports, "GitError", { enumerable: true, get: function () { return errors_1.GitError; } });
Object.defineProperty(exports, "ExecError", { enumerable: true, get: function () { return errors_1.ExecError; } });
__exportStar(require("./git-environment"), exports);
__exportStar(require("./ignore-closed-input-stream"), exports);
//# sourceMappingURL=index.js.map